import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
@Component({
  selector: 'app-report-three',
  templateUrl: './report-three.component.html',
  styleUrls: ['./report-three.component.scss']
})
export class ReportThreeComponent implements OnInit {
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  product_list = ["Milk", "Curd", "Butter Milk"]
  month_list_for_last_12_months: any = [];
  selected_month: any;
  selected_product: any;
  document_file: any = null;
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;

    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }

  getClicked() {
    let data_dict = {
      'selected_month': this.selected_month['month_in_integer'] + 1,
      'selected_year': this.selected_month['year'],
    };
    console.log(data_dict);
    this.is_data_available = false;
    this.document_file = null;
    this.httpService.serveReportThree(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
